/**
 * ! This file was generated by swagger-typescript-api. Do not change the file directly.
 */

import { PRODUCT_JOURNEY_GIRAR } from '../../../shared/utils/src/apis-paths'

import {
  type CommonCustomErrorResponse,
  type CommonSubmitSurveyAnswerRequest,
  type ProblemDetails,
  type WebV1SurveysCheckDisplayListData,
  type WebV1SurveysCloseCreateData,
  type WebV1SurveysCreateData,
  type WebV1SurveysTriggersListData
} from './data-contracts'
import { type RequestParams, HttpClient } from './http-client'

class Surveys extends HttpClient {
  private static httpInstance = new HttpClient(`${PRODUCT_JOURNEY_GIRAR}/api/web/v1/surveys`)

  /**
   * No description
   *
   * @tags web
   * @name WebV1SurveysCreate
   * @request POST:/api/web/v1/surveys
   * @secure
   * @response `200` `WebV1SurveysCreateData` OK
   * @response `204` `void` No Content
   * @response `400` `CommonCustomErrorResponse` Bad Request
   * @response `403` `ProblemDetails` Forbidden
   */
  static async webV1SurveysCreate(data: CommonSubmitSurveyAnswerRequest, params: RequestParams = {}) {
    return this.httpInstance.post<WebV1SurveysCreateData, CommonCustomErrorResponse | ProblemDetails>({
      url: ``,
      body: data,
      ...params
    })
  }

  /**
   * No description
   *
   * @tags web
   * @name WebV1SurveysCheckDisplayList
   * @request GET:/api/web/v1/surveys/{key}/check-display
   * @secure
   * @response `200` `WebV1SurveysCheckDisplayListData` OK
   * @response `400` `CommonCustomErrorResponse` Bad Request
   * @response `403` `ProblemDetails` Forbidden
   */
  static async webV1SurveysCheckDisplayList(key: string, params: RequestParams = {}) {
    return this.httpInstance.get<WebV1SurveysCheckDisplayListData, CommonCustomErrorResponse | ProblemDetails>({
      url: `/${key}/check-display`,
      ...params
    })
  }

  /**
   * No description
   *
   * @tags web
   * @name WebV1SurveysCloseCreate
   * @request POST:/api/web/v1/surveys/{key}/close
   * @secure
   * @response `200` `WebV1SurveysCloseCreateData` OK
   * @response `204` `void` No Content
   * @response `400` `CommonCustomErrorResponse` Bad Request
   * @response `403` `ProblemDetails` Forbidden
   */
  static async webV1SurveysCloseCreate(key: string, params: RequestParams = {}) {
    return this.httpInstance.post<WebV1SurveysCloseCreateData, CommonCustomErrorResponse | ProblemDetails>({
      url: `/${key}/close`,
      ...params
    })
  }

  /**
   * No description
   *
   * @tags web
   * @name WebV1SurveysTriggersList
   * @request GET:/api/web/v1/surveys/triggers
   * @secure
   * @response `200` `WebV1SurveysTriggersListData` OK
   * @response `400` `CommonCustomErrorResponse` Bad Request
   * @response `403` `ProblemDetails` Forbidden
   */
  static async webV1SurveysTriggersList(params: RequestParams = {}) {
    return this.httpInstance.get<WebV1SurveysTriggersListData, CommonCustomErrorResponse | ProblemDetails>({
      url: `/triggers`,
      ...params
    })
  }
}

export default Surveys
